
export interface Notification {
    id: number;
    type: 'success' | 'info' | 'warning' | 'error';
    title: string;
    message: string;
    date: Date;
    read: boolean;
    icon?: string;
    user?: {
        name: string;
        avatar?: string;
    };
    action?: {
        type: string;
        details?: string;
    };
}

// Mock data - replace with actual data from your API
export const mockNotifications: Notification[] = [
    {
        id: 1,
        type: 'success',
        title: 'Account aangemaakt',
        message: 'Het account voor "John Doe" is succesvol aangemaakt.',
        date: new Date('2024-03-20T10:30:00'),
        read: false,
        icon: 'user-plus'
    },
    {
        id: 2,
        type: 'info',
        title: 'Product export',
        message: 'Je kunt nu je producten exporteren naar .json format.',
        date: new Date('2024-03-20T09:15:00'),
        read: true,
        icon: 'file-export',
    },
    {
        id: 3,
        type: 'warning',
        title: 'Foto\'s ontbrekend',
        message: 'De primaire foto\'s zijn nog niet volledig gevuld.',
        date: new Date('2024-03-19T09:45:00'),
        read: false,
        icon: 'image',
    },
    {
        id: 4,
        type: 'success',
        title: 'Upload voltooid',
        message: 'De afbeeldingen zijn succesvol geüpload.',
        date: new Date('2024-03-19T14:20:00'),
        read: true,
        icon: 'upload',
    },
    {
        id: 5,
        type: 'info',
        title: 'Systeem update',
        message: 'Er is een nieuwe versie van het systeem beschikbaar met verbeterde prestaties.',
        date: new Date(),
        read: false,
        icon: 'update',
     },
    {
        id: 6,
        type: 'success',
        title: 'Import voltooid',
        message: 'Het importeren is succesvol uitgevoerd.',
        date: new Date(new Date().getTime() - 1000 * 60 * 60 * 24),
        read: false,
        icon: 'file-import',
    }
]